import type { ScreenSchema } from './types';

// Cards can contain any screen template as their body, including splits
// (card.left[], card.right[]) and compound screens (card.templates[]).
// We include two levels of inline iteration:
//   1. screen.cards[] — each card's own heading/text/instructions label
//   2. card.templates[] / card.left[] / card.right[] — one level of nested content
// We deliberately stop there: recursing deeper would make the intro audio
// very long (full body of every nested screen), which is rarely useful.
// For cards that open lightboxes (card.opens), only the card's own label
// is included — the lightbox content is a separate screen with its own audio.
//
// managesOwnSectionAudio: screen-cards.vue owns section entry playback. JiT
// synthesis for the combined intro can take longer than scroll-section handoff;
// we re-check sectionActive after resolveSlot before calling play().
const cardsSchema: ScreenSchema = {
  template: 'cards',
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        // Screen-level intro content
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        // Each card's label and inline body text
        {
          iterateField: 'cards',
          parts: [
            { field: 'heading', fallback: ['subheading', 'title'] },
            { field: 'text' },
            { field: 'instructions' },
            // For cards that embed a split layout (left/right content arrays)
            {
              iterateField: 'left',
              parts: [
                { field: 'heading', fallback: ['subheading', 'title'] },
                { field: 'text' }
              ]
            },
            {
              iterateField: 'right',
              parts: [
                { field: 'heading', fallback: ['subheading', 'title'] },
                { field: 'text' }
              ]
            },
            // For cards that embed a templates[] array
            {
              iterateField: 'templates',
              parts: [
                { field: 'heading', fallback: ['subheading', 'title'] },
                { field: 'text' }
              ]
            }
          ]
        }
      ]
    }
  }
};

export default cardsSchema;
